const en = {
  general: {
    error: 'Something went wrong. Please try again later.',
    seriousError: 'Something went wrong.<br />Please try again or contact us at <b>support@tape.ooo</b>.',
  },
  error: 'Something went wrong.',

  hello: 'Hello world',
  language: {
    en: 'English',
    ko: 'Korean',
  },
  yes: 'Yes',
  no: 'No',
  cancel: 'Cancel',
  languageMenu: 'Language',
  selectDateTime: 'Select date and time',
  or: 'or',
  success: 'success',
  signInTitle: 'Welcome to Tape 👋',
  signInContent: `We'll sign you in or create an<br />account if you don't have one yet.`,
  signInVerifyTitle: `We've sent a verification<br />code to your email 💌`,
  signInVerifyContent: 'Please check your inbox and paste<br />the verification code below.',
  signInVerifyLabel: 'Verification Code',
  signInVerifyHint: 'Enter the verification code',
  signInVerifiedTitle: `You're almost in!`,
  signInVerifiedContent: `Let your audience know who you are!`,
  signInVerifiedLabel: 'Name',
  signIn: 'Sign In',
  signOut: 'Sign Out',
  signUp: 'Sign Up',
  guestSignUpTitle: 'Continue as ',
  goSignUp: 'Sign Up',
  tryForFree: 'Try for Free',
  getStarted: 'Get Started',
  bookDemo: 'Book a demo',
  resetPassword: 'Reset Password',
  changePassword: 'Change Password',
  signInWithGoogle: 'Continue with Google',
  signUpWithGoogle: 'Continue with Google',
  msgSignInFailed: "We couldn't find an account that <br />matches your information.<br />",
  policyText:
    'By continuing you acknowledge that you have read and<br />understood, and agree to Tapes <u><a href="https://taperlabs.notion.site/Terms-of-Service-91bdd3bad41448318c3d32d9a332b6b7" target="_blank">Terms of Service</a></u> and <u><a href="https://taperlabs.notion.site/Privacy-Policy-770ef1b2cccb4defb2c085cda5f67de8" target="_blank">Privacy Policy</a>.</u>',
  email: 'Email',
  emailAddress: 'Email Address',
  msgEnterEmail: 'Enter your email address',
  msgCheckEmailFormat: 'Check the email address',
  msgCheckVerifyFormat: 'Check the verification code',
  msgEmailAlreadyInUse: 'The email address is already in use by another account.',
  msgPasswordMinLength: 'Password must be at least 8 characters long',
  msgVerifyCodeMinLength: 'Sign up code must be 6 characters',
  msgWorkspaceNameMinLength: 'Workspace name must be at least 2 characters long',
  password: 'Password',
  msgEnterNewPassword: 'Enter new password',
  msgEnterPassword: 'Enter your password',
  msgWrongPassword: 'Enter the correct password',
  verifyCode: 'Sign Up Code',
  msgEnterVerifyCode: 'Enter the verification code',
  userFullName: 'Full Name',
  msgEnterUserFullName: 'Enter your full name',
  userDisplayName: 'Display Name',
  msgEnterUserDisplayName: 'Enter your display name',
  optional: 'Optional',
  continueWithEmail: 'Continue with Email',
  createNewAccount: 'Create a new account',
  welcomeToTape: 'Welcome to Tape',
  welcomeDesc: 'Create or Join a Workspace to Start',
  joinOrCreateDesc: 'Create or Join a Workspace',
  joinInvitedWorkspace: 'Join {wsName}',
  joinInvitedWorkspaceDesc: 'Confirm and join the workspace',
  join: 'Join',
  msgUserAlreadyJoined: 'You are already a member of this workspace.',
  msgMagicLinkError: 'This link is not available.<br>Please contact an admin to add you as a member.',
  createWorkspace: 'Create a Workspace',
  createWorkspaceDesc: 'Some details for your team',
  addLogo: 'Add a Logo',
  workspaceName: 'Workspace Name',
  msgEnterWsName: 'Enter your workspace name',
  workspaceDomain: 'Workspace Domain',
  msgEnterWsDomain: 'Enter your workspace domain',
  msgWorkspaceDomainNotAvailable: 'This domain already exists or is not available',
  wsTeamType: 'Team Type',
  msgSelectWsTeamType: 'Select Team Type',
  inviteTeammates: 'Invite Your Teammates',
  inviteTeammatesDone: 'Your teammates will receive invitation emails shortly.',
  inviteTeammatesDesc: 'Who deserves to be saved from endless video conferences and messengers?',
  inviteTeammatesCompleteDesc: 'Your teammates will receive invitation emails shortly.',
  msgRedirectDesc: 'You will be redirected to the workspace in 3 seconds.',
  joinWorkspace: 'Join a Workspace',
  joinWorkspaceDesc: 'Enter your team workspace domain',
  msgCheckWorkspaceDomain:
    'Check workspace domain.<br/>Tip, You can join via invitation email also.<br/>Ask your workspace manager.',
  continue: 'Continue',
  joinWorkspaceRequestDesc: 'We’ll ask the admin for your access',
  joinWorkspaceComplete: 'Done!',
  joinWorkspaceCompleteDesc: 'We will send you an email once the admin confirm.',
  sendAccessRequest: 'Send an Access Request',
  // TODO : 아래 문구 문법 수정 필요
  // msgAlreadyExist: 'You either already exist or are waiting for your request to be accepted.',
  goToWorkspace: 'Go to Workspace',
  searchMeeting: 'Search meetings',
  search: 'Search',
  profilePhoto: 'Profile Photo',
  uploadProfilePicture: 'Upload Profile Picture',
  rename: 'Rename',
  delete: 'Delete',
  share: 'Share',
  end: 'End',
  ended: 'Ended',
  restart: 'Restart',
  deleteAccount: 'Delete Account',
  deleteAccountConfirmMsg:
    'This action cannot be undone. This will permanently delete your entire account. Please confirm.',
  cannotUndoneMsg: 'This action cannot be undone. Are you sure?',
  change: 'Change',
  update: 'Update',
  upload: 'Upload',
  record: 'Record',
  text: 'Text',
  calendly: 'Calendly',
  poll: 'Poll',
  vote: 'Vote',
  voteAgain: 'Vote Again',
  pollDialogTitle: 'Create a poll',
  pollDialogQuestionTitle: 'Create question',
  pollDialogQuestionHint: 'Write your question',
  pollDialogChoiceTitle: 'Enter choices below',
  setting: 'Setting',
  workspaceIcon: 'Workspace Icon',
  domainName: 'Domain Name',
  addMember: 'Add Teammates',
  add: 'Add',
  manageMembers: 'Manage Members',
  viewMembers: 'View Members',
  manage: 'Manage',
  view: 'View',
  deleteWorkspace: 'Delete Entire Workspace',
  deleteWorkspaceConfirmMsg:
    '<p>This action cannot be undone. This will permanently delete the workspace, including all videos and audio.<br><br>Please type the workspace name to confirm.<p>',
  leaveWorkspace: 'Leave Workspace',
  leaveWorkspaceConfirmMsg: 'Do you want to leave the Workspace?',
  leave: 'Leave',
  startMeeting: 'Create a New Tape',
  startConversation: 'Start a New Conversation',
  signInToSpeak: 'Sign In To Speak',
  enterNote: 'Enter Note',
  enterText: 'Enter Text',
  enterTitle: 'Enter Title',
  enterChoice: 'Enter Choice',
  enterClipTitle: 'Enter Clip Title',
  recordingSettings: 'Recording Settings',
  audioInput: 'Audio Input',
  videoInput: 'Video Input',
  audioPlaceHolder: 'Select Audio',
  videoPlaceHolder: 'Select Video',
  emptyMeetingTitle: 'Create the first Tape',
  emptyMeetingBody: 'Click the button below to start a whole new level of communication.',
  firstMeetingTopic: "'s new Tape",
  heroPhrase0: 'Less Meetings<br />More',
  heroPhrase1: ' Creating',
  heroDescription0: 'Replace meetings with interactive video messaging',
  heroDescription1: ' - No installation required. <br/>',
  heroDescription2: 'Record and share short videos of your screen and face and get feedback.',
  diffTitle0: 'Get things done,<br />on your time',
  diffDescription0:
    'Free yourself from scheduling to get things done by recording and sharing your work, feedback, or questions.',
  diffTitle1: 'Never miss a thing',
  diffDescription1:
    'One topic, one thread. Unlike Slack channels, you can understand what’s new and what to follow up on in a split second.',
  diffTitle2: 'Minimize<br />interruptions',
  diffDescription2: 'Assigning who to follow up on leads your team to stay productive and focused.',
  usecaseTitle: 'Built for team communication',
  usecaseDescription:
    'Tape can be used for a variety of communication types. Even more effective than real-time communication.',
  usecaseDailyStandup: 'Instead of Zoom calls, share daily updates with video or audio messages.',
  usecaseFeedbackQuestion:
    'Spending too much time on scheduling calls for quick questions and feedback? Just Record and share instantly!',
  usecaseCodeReview: 'Clear and detailed video explanations to visualize commit messages.',
  usecaseProjectUpdate: 'Get your team on the same page without going through hectic schedules.',
  usecaseWebinar: 'Time-zone-free webinars for everyone to freely ask questions.',
  usecaseEtc: 'Stay tuned for more updates to come.',
  termsOfService:
    '<a href="https://taperlabs.notion.site/Terms-of-Service-91bdd3bad41448318c3d32d9a332b6b7">Terms of Service</a>',
  privacyPolicy:
    '<a href="https://taperlabs.notion.site/Privacy-Policy-770ef1b2cccb4defb2c085cda5f67de8">Privacy Policy</a>',
  confirm: 'Confirm',
  confirmMsg: 'This action cannot be undone.',
  updateSuccess: 'Successfully updated.',
  updateFail: 'Failed upload : ',
  workingFeatureMsg: 'We apologize. This feature is not ready yet. We are working hard to bring it to you ASAP!🙇‍♀️',
  noAccessMsg: 'You do not have access.<br />Please contact an admin to add you as a member.',
  channelNoAccess1: 'This link is currently disabled. ️🙁',
  channelNoAccess2: 'Please contact the owner and ask enable it again.',
  notSupportedEnvMsgMobile:
    "We apologize.🙇‍♀️ <br />Tape doesn't support mobile browsers just yet. <br />Tape works best in Chrome and Edge on PC/Mac.",
  notSupportedEnvMsg:
    "We apologize.🙇‍♀️ Tape doesn't support your browser just yet. Tape works best in Chrome and Edge on PC/Mac.",
  recordingNotSupportedMsg:
    "We apologize.🙇‍♀️ Your browser doesn't allow recording video and audio yet. Tape works best in Chrome and Edge on PC/Mac.",
  notAvailableFeatureMsg:
    'We apologize.🙇‍♀️ This feature is not available yet. We are working very very hard to get it done soon. Please contact us at support@tape.ooo for any support!',
  recordFailMsg:
    ' 🙇🏻‍♂️ We are sorry. Recording has just force stopped due to browser error. Will you give us second chance? 🥺',
  reload: 'Reload',
  shareMeetingTitle: 'Share Tape',
  deleteCurrentClip: 'Delete Current Clip',
  deleteMeeting: 'Delete Tape',
  deleteComment: 'Delete Comment',
  deleteMeetingContent: 'This action cannot be undone. This will permanently delete all clips in the Tape.',
  deleteCancel: 'Cancel',
  deleteClipSuccess: 'Clip deleted',
  deleteMeetingSuccess: 'Tape deleted',
  deleteCommentSuccess: 'Comment deleted',
  deleteSection: 'Section deleted',
  deleteSectionContent: 'This action cannot be undone. This will permanently delete all clips in the section.',
  deleteSectionSuccess: 'Section deleted',
  noClipToDelete: 'No clip to delete',
  alreadyDeleted: 'Already deleted',
  completedAcceptJoinWs: 'Done.<br />Now the new member can access the workspace.',
  notManagerErrorMsg: 'We are sorry. You are not authorized to grant this request.',
  invitedWorkspace: 'Invited workspace',
  successUpdateMemberType: 'Member type updated',
  browserAccessPermission: 'Give your browser access to the camera and microphone.',
  systemDenied: 'Permission denied by System',
  notReadableError: 'Screen sharing is not available. Please restart the browser and try again.',
  sendResetPassWord: 'Done! Check your inbox for the link to reset your password.',
  setClipFail: 'Failed to create clip. Please try again or contact us at <b>support@tape.ooo</b> 🙋‍♀️',
  setSubTitleFail: 'Failed to upload subtitle. Please try again or contact us at <b>support@tape.ooo</b> 🙋‍♀️',
  subtitleAlreadyExist: 'A subtitle for the selected language already exists. Please delete it and try again.',
  uploadSubtitleSuccess: 'Upload subtitle success',
  openSubtitleDialogError: 'Subtitle can only be uploaded by the clip uploader or the user created the Tape.',
  inputStringErr: 'Please check your input.',
  deviceNotFound: 'Device not found.',
  moveToMeetingTitle: 'Move Tape To ...',
  joinOrCreateWorkspace: '+ Join or create workspace',
  wsNotExistMsg: 'Nothing here 👀',
  eMailNotificationSetting: 'Email Notification',
  copiedClipboardUrl: 'The URL has been copied to clipboard.',
  copiedClipboardText: 'The contents have been copied to clipboard.',
  failedCopy: 'Failed to copy. Please try again.',
  textRecordTitle: 'What do you want to share?',
  notiCreateMt: '<b>%s</b> started a new Tape <b>%s</b>',
  notiCreateClip: '<b>%s</b> posted a clip to <b>%s</b>',
  notiWatchedClip: '<b>%s</b> watched your clip in <b>%s</b>',
  notiRequestFollowUp: '<b>%s</b> is requested to follow up - <b>%s</b>',
  notiAnHour: '<b>%s</b> have a request due in 1 hour - <b>%s</b>',
  notiExpiration: 'Complete your follow up request - <b>%s</b>',
  notiResponseFollowUp: '<b>%s</b> will follow up - <b>%s</b>',
  notiRequestFollowUpTitle: 'is requested to respond.',
  notiMention: '<b>%s</b> mentioned you in a <b>%s</b>',
  notiEndedMt: '<b>%s</b> has ended the Tape - <b>%s</b>',
  notiRestartedMt: '<b>%s</b> has restarted the Tape - <b>%s</b>',
  notiCreateComment: '<b>%s</b> commented <b>%s</b> on <b>%s</b>',
  noNotification: 'No notification yet 👀',
  reservedClipAlert: ' is supposed to respond soon.</br>Are you sure you want to respond?',
  reservedClipRequested: ' is requested</br> to respond.',
  reservedClipWill: ' will respond.',
  recordNow: 'Record Now',
  requestResponse: 'Request response',
  requestSubTitle: 'Who would you like to request a response from?',
  willFollowUp: 'Will follow up',
  request: 'Request',
  skip: 'Skip',
  done: 'Done',
  addDueDate: 'Add Due Date',
  tags: 'Tags',
  addTags: 'Add Tags +',
  viewers: 'Who viewed this clip',
  noOneWatched: 'No one watched',
  privateOnBoardingTitleGreeting: 'Hi %s',
  privateOnBoardingTitleDescription: ', this is your private space',
  privateOnBoardingBody:
    'You can only access the Tapes in private space unless you change the access option when you share them.',
  privateOnBoardingStep1Title: 'Step 1 - Start a Tape',
  privateOnBoardingStep1Description0: 'In a Tape, you can have a conversation by exchanging short video messages.',
  privateOnBoardingStep1Description1: 'All messages will be saved in a thread!',
  privateOnBoardingStep1Description2: 'Click the button at the bottom to start 👇',
  privateOnBoardingStep2Title: 'Step 2 - Share it',
  privateOnBoardingStep2Description0:
    'Get a link by clicking the Share button at the top right of the Tape screen and share it with someone you want to talk to.',
  privateOnBoardingStep3Title: 'Step 3 - Wait for a reply',
  privateOnBoardingStep3Description0: 'Done! We will send a notification when someone posts a reply.',
  workspaceOnBoardingTitleDescription: 'This is your team’s workspace',
  workspaceOnBoardingBody:
    'Anyone in the workspace can access the Tapes here by default. Start a Tape and your teammates will see it immediately.',
  workspaceOnBoardingStep1Title: 'Step 1 - Add teammates',
  workspaceOnBoardingStep1Description0:
    'Ask the manager to add teammates to the workspace. Once they get access, they will be able to access all the Tapes here.',
  workspaceOnBoardingStep2Title: 'Step 2 - Start a Tape',
  workspaceOnBoardingStep2Description0:
    'Click the record button at the bottom of the screen to start a Tape and record a message!',
  workspaceOnBoardingStep3Title: 'Step 3 - Wait for responses',
  workspaceOnBoardingStep3Description0: 'Done! We will send a notification when your teammate posts a message.',
  onboardingGetStarted: "Let's get started.",
  noMsg: 'No messages yet.',
  noMsgEndedClip0: `Now, It's `,
  noMsgEndedClip1: 'your turn',
  noMsgToDo: 'Record or request one.',
  noMsgToDoDetail: 'Click the record button 🔴 at the bottom of the screen to start recording',
  noMsgVideoTopicTitle: 'Learn about Topic based Template',
  noMsgVideoChronologicalTitle: 'Learn about Chronological Template',
  clickToStartRecording: 'Click to Start Recording',
  titleEmpty: 'No clips yet',
  titleLast: 'Add a new clip',
  msgEmpty: `Start recording meetings or updates by either pressing the 'Record Now' button below or pressing`,
  finish: 'Finish',
  retry: 'Retry',
  progressUploadingTitle: 'Do not close the tab or refresh🖐',
  progressCompleteTitle: 'Complete ✅',
  failedUploadTitle: 'Failed to upload. 😥 Retry?',
  failedUploadSubTitle: 'We promise we will do better this time.',
  discard: 'Discard',
  inbox: 'Inbox',
  inboxEmpty: 'Your Inbox is empty',
  assignedToMe: 'Assigned To Me',
  assignedSubTitle: 'Your Follow Up',
  assignedEmpty: 'All clear. Nothing to follow up💪',
  copyLinkUrl: 'Copy Tape URL',
  msgIncorrectCode: 'Incorrect Code.',
  msgSendVerifyCodeInfo:
    'We just sent you a temporary verification code. Please check your inbox and paste the verification code below.',
  notiPrefAlways: 'Always',
  notiPrefRequested: "Only when I'm requested",
  notiPrefNever: 'Never',
  remindContent: 'Are you sure?',
  magicLinkTitle: 'Join your team on %s',
  magicLinkContent: '%s has created a new Tape workspace for %s. Click on the link to join!',
  fileUploadTitle: 'Upload Video',
  subTitleUploadTitle: 'Upload Subtitle',
  selectSubTitleFileTitle: 'Select Subtitle File',
  selectSubTitleLanguageTitle: 'Select Language',
  fileUploadContent: 'Drag and drop here to upload',
  fileUploadContent2: '* MP4 (H.264) files can be uploaded.',
  subTitleUploadContent: '* .srt/.vtt files can be uploaded.',
  fileUploadBtn: 'Browse Files',
  fileUploadFailed: 'The file can’t be uploaded to Tape️. Please try another file.',
  fileUploadChecking: 'Checking the video ...',
  subTitleUploadChecking: 'Checking the subtitle ...',
  onlyOneVideo: 'Only one file at a time can be uploaded.',
  onlySrtFile: 'Only srt/vtt file can be uploaded',
  onlyMp4Video: 'Only mp4 file can be uploaded',
  fileSizeError: 'Video size should be less than 2GB.',
  codecError: 'This video cannot be uploaded.',
  addNewSection: 'Add New Section',
  selectTemplateTitle: 'How would you like to organize your Tape?',
  next: 'Next',
  enterSectionTitle: 'Enter section title',
  selectSectionTitle: 'Select Section',
  createSectionTitle: 'Create a new section',
  post: 'Post',
  save: 'Save',
  comment: 'Comment',
  transcript: 'Transcript',
  summary: 'Summary',
  translate: 'Translate',
  followUpAlreadyExsit: ' is supposed to respond soon.',
  download: 'Download',
  notiEndedMeeting: 'This Tape has ended.',
  notEnoughStorage: 'Not enough storage space',
  unTitledSection: 'Untitled Section',
  preferenceDialogTitle: `Can't share your`,
  preferenceDialogContent1: `Your browser might not have`,
  preferenceDialogContent2: `permission on your computer. Go to`,
  preferenceDialogContentLink: 'System Preferences.',
  recipient: 'Recipient',
  requestContentTitle: 'What would you like to hear about?',
  dueDate: 'Due Date',
  enterTopicHint: 'Enter Topic',
  selectDateHint: 'Click here to add due date',
  requestedBy: 'By',
  about: 'About',
  joinTheWorkspaceFirstMsg: 'Join the workspace first to request a response.',
  requestResponseTitle: 'Are you ready to respond?',
  requestToMeTitle: 'Record Now',
  videoNotConvertedYet: 'The video is not ready to download just yet.😞 Please try again in a moment.',
  editName: 'Edit Name',
  chNotExist: 'Something went wrong. Please try again.',
  chMtLoadFailed: 'Something went wrong. Please try again.',
  addChannelFailed: 'Something went wrong. Please try again.',
  addChannelSuccess: 'Channel Created',
  renamePlaceholder: 'Enter channel name',
  renameChannelLengthError: "Channel name can't be empty.",
  renameChannelSameError: 'This channel name already exists. Please try another channel name.',
  renameChannelFailed: 'Something went wrong. Please try again.',
  renameChannelSuccess: 'The channel name has been updated.',
  deleteChannel: 'Delete Channel',
  deleteChannelContent: 'This action cannot be undone. This will permanently delete all Tapes in the channel.',
  deleteChannelFailed: 'Something went wrong. Please try again.',
  deleteChannelSuccess: 'The channel has been completely deleted.',
  deleteCommentFailed: 'Something went wrong. Please try again.',
  setEmojiError: 'This emoji cannot be drawn',
  deleteEmojiError: 'This emoji cannot be deleted',
  audioDeviceNotFoundError: 'No audio device available.',
  videoDeviceNotFoundError: 'No video device available.',
  noAudioDetectedNoti: `We're not detecting much sound from your mic. Please check your mic before recording.`,
  noAudioDetectedConfirm: `We're not detecting much sound from your mic.<br />Would you still like to continue?`,
  receivingSettingTitle: 'Receiving Setting',
  channelIconSettingTitle: 'Upload a photo',
  teamChannelTitle: 'Team Channels',
  videoNotUploaded:
    'The video is being prepared for the best watching experience.<br />Please come check again in a minute 🙏🏻',
  invalidVideo: 'Oops, we need just a little more time 😅',
  videoUploadCheck: 'Check Again Now',
  videoNotFound: 'Video Not Found 😕',
  clipUploadingError: `A video is currently being uploaded. Please try again when it's done.`,
  paymentSuccessfulMsgTitle: 'Thank you! 🙏🏻',
  paymentSuccessfulMsgContent: 'You are all set!',
  paymentResultbtnMsg: 'Go back to my workspace',
  payAnnuallyInfo: 'When pay annually',
  plusDescriptionContent1: 'Unlimited Minutes',
  // plusDescriptionContent2: '60 min / Video',
  plusDescriptionContent3: 'Premium Features',
  plusDescriptionContent4: '(Video Upload and more)',
  freeDescriptionContent1: 'Up to 180 Minutes',
  freeDescriptionContent2: '5 min / Video',
  freeDescriptionContent3: 'Basic Features',
  freeDescriptionContent4: '(Unlimited comments and more)',
  emailAdminUpgrade: 'We will send an email to the admin to let you know that you need an upgrade.',
  beforeLeaveChangePlanMsg:
    'To leave this workspace, please downgrade your plan first. You can ask the admin or contact us.',
  beforeDeleteChangePlanMsg: 'To delete workspace, please cancel Plus plan first. ',
  needToRecordVideoLonger: 'Need to record video longer?',
  joinTheWorkspaceToRecordLongerVideo: 'Join the workspace to record longer video.',
  learnMore: 'Learn More',
  sendRequest: 'Send a Request',
  later: 'Later',
  upgrade: 'Upgrade',
  askAdmin: 'Ask Admin',
  requestAdmin: 'Request Admin',
  askAdminInfo: 'To change plan, please contact the admin of your workspace',
  seeFeatureBenefit: 'See all features and benefits',
  changePlan: 'Change Plan',
  markAllasPlus: 'Mark All as Plus',
  summaryOfChanges: 'Summary of changes',
  yourPlan: 'Your Plan',
  billing: 'Billing',
  billingInfo: 'To make changes on payment method, view invoice history, or cancel plan, visit our customer portal.',
  openCustomerPortal: 'Open Customer Portal',
  openCustomerPortalErrMsg: 'Upgrade your plan to access the customer portal!',
  tooltipQuickRecord: 'This will create a Tape in My Library.',
  linkWithGoogleError: 'Please use the same email.',
  transcriptUpgradePlan: 'Upgrade to use feature.',
  transcriptLoadingTitle: '🤖 Our AI engine is generating your transcript.',
  transcriptLoadingContent: 'You will be able to view it here shortly. Hold tight!',
  transcriptFailContent: `We couldn't detect any audible speech in this clip. 😯`,
  transcriptUncheckedOrTooShortContent: `The transcription for this clip has been turned off.`,

  summaryUpgradePlan: 'Upgrade to use summarization feature.',
  summaryLoadingTitle: 'Summarizing your video 🤖',
  summaryLoadingContent: 'Our AI engine is currently processing your video.\nPlease give us a moment!',
  summaryFailContent: `Tape couldn't generate summary from this clip. 😯`,
  summaryUncheckedOrTooShortContent: `The summarization for this clip has been turned off.`,

  noSegments: 'Nothing to show 😰',
  copy: 'Copy',
  edit: 'Edit',
  chooseTemplateTitle: 'Choose a template',
  chooseTemplateSubTitle:
    'Choosing a template helps our AI engine in generating a more accurate summary of your video.',
  templateBtnCustom: 'Custom',
  templateBtnNone: 'None',
  templateBtnMeetingSummary: 'Meeting Summary',
  templateBtnProjectUpdate: 'Project Update',
  templateBtnBugreport: 'Bug Reporting',
  templateBtnProductdemo: 'Product Demo',
  regenerate: 'Regenerate',
  export: 'Export',
  msgSummaryEmphasis: '🪄 Choosing a template will significantly improve the summarization quality.',
}

export default en
